export const searchChallengeInitialState = {
  filters: {
    title: "",
    location: "",
    challengeType: "",
    challengeTypeNames: "",
    jobType: "",
    rating: "",
  },
  currentPage: 1,
  totalPages: 1,
  challengeList: [],
  isChallengeListLoading: false,
};

export const searchChallengeReducer = (state, action) => {
  switch (action.type) {
    case "SET_CHALLENGE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_CHALLENGE_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_CHALLENGE_DATA":
      return {
        ...state,
        challengeList: action.payload,
        isChallengeListLoading: false,
      };
    case "SET_CHALLENGE_TOTAL_PAGES":
      return { ...state, totalPages: action.payload };
    case "SET_CHALLENGE_LOADING":
      return { ...state, isChallengeListLoading: action.payload };
    case "RESET_CHALLENGE_FILTERS":
      return {
        ...searchChallengeInitialState,
      };
    default:
      return state;
  }
};
